import React from 'react';
import Icon from '../Icon';

interface IProps {
    className?: string;
}

export default ({ className }: IProps) => <Icon icon="preloader" className={className} />;
